import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const box = defineConnector({
  identifier: "box",
  name: "Box",
  tagLine: "Enterprise content management",
  logo,
  protocol: "http",
  tags: ["documents"],
  defaultUrlPattern: () => "https://.*\\.box\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Connect your Box account",
      items: [
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://account.box.com/api/oauth2/authorize",
    tokenEndpoint: () => "https://api.box.com/oauth2/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "env",
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.box.com/2.0/users/me",
  },
});
